<template>
    <div class="d-flex align-center flex-wrap" style="gap: 12px 0">
        <div class="d-flex justify-start day-checkbox flex-shrink-0">
            <v-checkbox
                v-for="(day, index) in days"
                :key="day"
                v-model="dayOfWeeks[index]"
                class="mx-1"
                :data-cy="day"
                hide-details
            >
                <template v-slot:label>
                    <p class="mb-0">
                        {{ $t(`supplier.days.${day}`) }}
                    </p>
                </template>
            </v-checkbox>
        </div>
        <div>
            <v-btn
                variant="text"
                size="small"
                color="primary"
                class="text-none"
                data-cy="all"
                :class="{'text-decoration-underline': checker === 'all'}"
                @click="checker = 'all'"
            >
                {{ $t('supplier.all') }}
            </v-btn>
            <v-btn
                variant="text"
                size="small"
                color="primary"
                class="text-none"
                data-cy="none"
                :class="{'text-decoration-underline': checker === 'none'}"
                @click="checker = 'none'"
            >
                {{ $t('supplier.none') }}
            </v-btn>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, VModel, Vue} from 'vue-facing-decorator'

    @Component
    export class DaysPicker extends Vue {
        @VModel({default: () => []}) dayOfWeeks
        days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

        get checker() {
            if (this.dayOfWeeks.every(el => !!el)) {
                return 'all'
            } else if (this.dayOfWeeks.every(el => !el)) {
                return 'none'
            }

            return null
        }

        set checker(val) {
            val === 'all'
                ? (this.dayOfWeeks = [true, true, true, true, true, true, true])
                : (this.dayOfWeeks = [false, false, false, false, false, false, false])
        }
    }

    export default DaysPicker
</script>

<style scoped lang="scss">
    .day-checkbox {
        :deep(.v-selection-control) {
            flex-direction: column-reverse;
            align-items: center;

            .v-label {
                margin-left: 0;
            }
        }
    }
</style>
